var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/Sign Out/Line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.3528 10.0006C7.72073 9.98666 8.03025 10.2737 8.04414 10.6416C8.07545 11.4711 8.11944 12.0764 8.16267 12.5105C8.20526 12.938 8.46332 13.1952 8.82304 13.2391C9.24721 13.291 9.84557 13.3334 10.6667 13.3334C11.4878 13.3334 12.0862 13.291 12.5103 13.2391C12.8699 13.1952 13.128 12.9379 13.1706 12.5103C13.2509 11.7046 13.3333 10.3126 13.3333 8.00008C13.3333 5.68754 13.2509 4.29555 13.1706 3.48987C13.128 3.0623 12.8699 2.80499 12.5103 2.76104C12.0862 2.70919 11.4878 2.66675 10.6667 2.66675C9.84556 2.66675 9.2472 2.70918 8.82303 2.76103C8.46332 2.80501 8.20526 3.0622 8.16267 3.48966C8.11944 3.92371 8.07545 4.52911 8.04414 5.35856C8.03025 5.72649 7.72073 6.0135 7.3528 5.99961C6.98487 5.98572 6.69787 5.67619 6.71176 5.30827C6.7439 4.45691 6.78947 3.8237 6.83591 3.35749C6.93355 2.37738 7.61688 1.56522 8.66125 1.43755C9.14739 1.37813 9.80054 1.33341 10.6667 1.33341C11.5328 1.33341 12.186 1.37813 12.6721 1.43756C13.7166 1.56524 14.3998 2.37778 14.4974 3.3577C14.5834 4.22053 14.6667 5.65906 14.6667 8.00008C14.6667 10.3411 14.5834 11.7796 14.4974 12.6425C14.3998 13.6224 13.7166 14.4349 12.6721 14.5626C12.186 14.622 11.5328 14.6667 10.6667 14.6667C9.80054 14.6667 9.1474 14.622 8.66125 14.5626C7.61688 14.4349 6.93355 13.6228 6.83591 12.6427C6.78947 12.1765 6.7439 11.5432 6.71176 10.6919C6.69787 10.324 6.98487 10.0144 7.3528 10.0006Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.80475 9.86193C5.0651 10.1223 5.0651 10.5444 4.80475 10.8047C4.5444 11.0651 4.12229 11.0651 3.86194 10.8047L1.52861 8.4714C1.26826 8.21106 1.26826 7.78895 1.52861 7.5286L3.86194 5.19526C4.12229 4.93491 4.5444 4.93491 4.80475 5.19526C5.0651 5.45561 5.0651 5.87772 4.80475 6.13807L3.60949 7.33333H10C10.3682 7.33333 10.6667 7.63181 10.6667 8C10.6667 8.36819 10.3682 8.66667 10 8.66667L3.60949 8.66667L4.80475 9.86193Z",
    fill: "currentColor"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign-out.891aebaba6a2e0d4268543dc7ba37be7.svg";
export { ForwardRef as ReactComponent };